module.exports = __webpack_public_path__ + "resources/img/img-security-securegate-2.f78592c5660ff9d27d0b51521d5ed84c.png";